import script from "./apiKeysTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./apiKeysTable.vue?vue&type=script&setup=true&lang=ts"

import "./apiKeysTable.vue?vue&type=style&index=0&id=6c582251&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c582251"]])

export default __exports__